import { render, staticRenderFns } from "./TemplateFaecherliste.vue?vue&type=template&id=3a708192&"
import script from "./TemplateFaecherliste.vue?vue&type=script&lang=js&"
export * from "./TemplateFaecherliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports